export default __webpack_public_path__ + "static/media/NAB_Ui.5cfa547e.png";